import appConfig from "@/config/appConfig";
import { Button, Input, Spin } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { AiOutlineEye } from "react-icons/ai";
import { FaPlus } from "react-icons/fa";
import { FiEdit, FiTrash } from "react-icons/fi";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import { DataTable } from "@/components";
import { numberFormater, showAlert } from "@/utils";

const Planlist = () => {
  const [prepaidPlan, setPrepaidPlan] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const getPrepaidPlan = async () => {
    setIsLoading(true);
    try {
      const {
        data: { result, count },
      } = await axios.get(`/subscription`, {
        withCredentials: true,
        params: { searchText, unknown: true, page, limit },
      });
      setTotal(count || 0);
      setPrepaidPlan(result);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    document.title = appConfig.name + " - All Subscription Plan";
    getPrepaidPlan();
  }, [searchText, page, limit]);

  const columns = [
    {
      title: "No.",
      render: (_, __, idx) => (page - 1) * limit + idx + 1,
      width: "60px",
      align: "center",
    },
    {
      title: "Plan Name",
      render: (_, row) => row.name || "--",
      align: "center",
    },
    {
      title: "Price",
      render: (_, row) => (row.planType === "Free" ? "Free" : `${row?.currency} ${numberFormater(row?.price)}`),
      align: "center",
    },
    {
      title: "Admin",
      render: (_, row) => row?.siteAdminCount || 0,
      align: "center",
    },
    {
      title: "Site",
      render: (_, row) => row?.siteUserCount || 0,
      align: "center",
    },
    {
      title: "Public",
      render: (_, row) => row?.sitePublicCount || 0,
      align: "center",
    },
    {
      title: "Installer",
      render: (_, row) => row?.installerCount || 0,
      align: "center",
    },
    {
      title: "Location",
      render: (_, row) => row?.locationCount || 0,
      align: "center",
    },
    {
      title: "Device",
      render: (_, row) => row?.deviceCount || 0,
      align: "center",
    },
    {
      title: "Dashboard",
      render: (_, row) => row?.dashboardCount || 0,
      align: "center",
    },
    {
      title: "Action",
      render: (_, row) => (
        <div>
          <Link to={`/view-plan/` + row._id} className="btn btn-az-primary me-1" title="View Plan">
            <AiOutlineEye />
          </Link>
          <Link to={`/edit-plan/` + row._id} className="btn btn-edit me-1" title="Edit Plan">
            <FiEdit />
          </Link>
          <button
            className="btn btn-danger"
            title="Delete"
            onClick={() => deletePlan(row._id)}
            disabled={row?.haveAssigned}
          >
            <FiTrash />
          </button>
        </div>
      ),
      align: "center",
    },
  ];

  const deletePlan = async (subscriptionId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This prepaid plan will be deleted and could affect users who are assigned to it.",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`/subscription/` + subscriptionId, {
            withCredentials: true,
          })
          .then((res) => {
            getPrepaidPlan();
            showAlert(res.data);
          })
          .catch((err) => {
            showAlert(err.response?.data);
          });
      }
    });
  };

  return (
    <div className="az-content-body p-0 px-md-3">
      <div className="row row-sm mg-b-15 mg-sm-b-20">
        <div className="col-lg-12">
          <div className="card card-dashboard-six">
            <div className="card-header d-flex flex-column flex-md-row g-3 align-items-start align-items-md-center pb-3">
              <div className="">
                <label className="az-content-label">Manage Subscription Plan</label>
                <span className="d-block py-2">All Subscription Plans</span>
              </div>
              <div className="ms-md-auto p-0">
                <Link to="/create-plan">
                  <Button icon={<FaPlus />} type="primary">
                    Create Plan
                  </Button>
                </Link>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-10"></div>
              <div className="col-md-2">
                <Input
                  type="search"
                  size="large"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Search"
                  // className="me-2"
                  aria-label="Search"
                />
              </div>
            </div>
            <Spin spinning={isLoading}>
              <DataTable
                dataSource={prepaidPlan}
                columns={columns}
                rowKey={(record) => record.id}
                pagination={{
                  defaultPageSize: 10,
                  current: page,
                  total,
                  showSizeChanger: true,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                  pageSizeOptions: [10, 20, 50],
                  responsive: true,
                }}
                onChange={({ current, pageSize }) => {
                  setPage(current);
                  setLimit(pageSize);
                }}
              />
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Planlist;
